export class EnvironmentUrls {
    base: string;
    api: string;
    identity: string;
    events: string;
}
